export default {
  en: {
    pageTitle: 'LDAP Settings',
    ldapConfigurationTitle: 'LDAP Configuration',
    msgNameAlreadyExist:
      'Upload failed, please use different name. The specified is already stored.',
    msgCertificateUploaded: 'Certificate uploaded',
    deleteAllRoleAssignmentsDialog: {
      btnConfirm: 'Delete Invalid Groups',
      header: 'Configuration contains invalid group permissions setting',
      body: (
        <div>
          Server configuration wasn’t saved because Group permissions settings
          is invalid.
          <br />
          Do you want to save server settings and remove all invalid group
          permissions?
        </div>
      ),
      btnSecondaryConfirm: 'Cancel',
    },
    configurations: {
      editConfig: 'Server Configuration',
      deleteConfig: {
        header: 'Configuration will be deleted',
        subHeader: 'Do you really want to delete configuration?',
        btnConfirm: 'Delete',
        btnSecondaryConfirm: 'Cancel',
      },
      groupPermissions: 'Group Permissions',
      type: {
        label: 'Type',
        ad: 'Active Directory',
        openLdap: 'OpenLDAP',
      },
      accountSuffixesPlaceholder: 'Insert suffix',
      accountSuffixes: 'Suffixes',
      accountSuffixesHelp: (
        <div>
          Enter all the aliases/suffixes for this domain. Each suffix must begin
          with <code>@</code>. If <strong>same</strong> user can login with more
          suffixes, for example <code>joe@europe.domain.com</code> or{' '}
          <code>joe@domain.com</code> then fill <code>@europe.domain.com</code>{' '}
          and <code>@domain.com</code>.
        </div>
      ),
      bindCredentials: 'Bind credentials',
      bindCredentialsHelp: (
        <div>
          Specify password for user filled in the field
          <code>Bind DN</code>
        </div>
      ),
      bindDN: 'Bind DN',
      bindDNHelp: (
        <div>
          This field must be an <u>escaped</u> distinguished name, such as{' '}
          <code>CN=Doe\, Joe,OU=europe,DC=your,DC=domain,DC=com</code>
        </div>
      ),
      server: {
        label: 'Servers',
        startTls: 'StartTLS',
        url: 'Hostname/IP address',
        port: 'Port',
        cert: 'Select certificate',
        btnUpload: 'Upload CA',
        fileUpload: 'File upload',
        name: 'Name',
        list: 'Use pre-configured LDAP servers',
        dns: 'Use DNS to find LDAP servers',
        domain: 'DNS domain value',
        domainHelp: 'Specify domain name from DNS SRV records',
        serviceName: 'Service location name',
        serviceNameHelp: 'The value for name attribute from DNS SRV record',
        useLdaps: 'Use LDAPs',
        btnAdd: 'Add Server',
      },
      searchBase: 'Search base',
      searchBaseHelp: (
        <div>
          Search base is a full path to organization unit including domain (
          <u>escaped</u>) , such as
          <code>OU=europe,DC=your,DC=domain,DC=com</code>
        </div>
      ),
      searchLogin: 'Search login attribute',
      roleAssignments: {
        boxTitle: 'Permissions settings',
        groupName: 'Group name',
        btnAdd: 'Add Group',
        role: 'Role',
        selectRolePlaceholder: 'Select role',
        anyUser: 'Authenticated user',
        anyUserHelp:
          'Any user that is not a member of a defined permission group',
        noResultsFound: 'No results found - type group name',
        menuTitle: 'Group',
      },
      nestedGroups: 'Groups',
      allowNestedGroups: 'Allow nested groups',
    },
    enabled: 'Enable LDAP Server',
    btnSave: 'Save',
    btnCancel: 'Cancel',
    btnAddConfiguration: ' Add Domain',
    btnAddServer: 'Add',
    btnRemove: 'Delete',
    btnUpdate: 'Update',
    btnEditDomain: 'Edit Domain',
    btnConfirm: 'Confirm',
    btnLabelDuringSaving: 'Verifying credentials',
    validation: {
      required: 'Required',
      requiredConfiguration: 'Please add new LDAP configuration',
      requiredServers: 'Please add server',
      requiredRole: 'Please add group name',
      suffixUniq: 'Suffix "{suffix}" is already used on other domain',
      urlStartsWith: 'Hostname must start with "ldap://" or "ldaps://"',
      suffixStartsWith: 'Suffix "{suffix}" must start with "@"',
      number: 'Must be number',
      invalidGroup: 'Invalid group',
      duplicitGroup: 'Duplicit group',
    },
    request: {
      ldapSettingsSaved: 'LDAP settings saved',
      criticalModification:
        'The server configuration has been saved, please check if group permissions are valid after this modification',
    },
  },
};
